import React from 'react';

import { AssistantMessage } from '../../features/assistant/interfaces/assistant.interface';
import AssistantAttachments from './AssistantAttachments';
import RichText from './RichText';

interface Props {
  message: AssistantMessage;
  onNavigate: () => void;
}

const AssistantMessageBubble: React.FC<Props> = ({ message, onNavigate }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`flex flex-col gap-1 ${isUser ? 'items-end' : 'items-start'}`}>
      {message.text ? (
        <div
          className={`max-w-[88%] break-words rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed ${
            isUser
              ? 'rounded-br-md text-white'
              : message.isError
                ? 'rounded-bl-md border border-red-200 bg-red-50 text-red-800'
                : 'rounded-bl-md border border-gray-200 bg-white text-[#212121] shadow-sm'
          }`}
          style={{
            fontFamily: "'Poppins', sans-serif",
            ...(isUser ? { backgroundColor: '#E55325' } : {}),
          }}
        >
          {isUser ? (
            <span className="whitespace-pre-wrap">{message.text}</span>
          ) : (
            <RichText text={message.text} />
          )}
        </div>
      ) : null}

      {message.attachments.length ? (
        <div className="w-full max-w-[88%]">
          {message.attachments.map((attachment, index) => (
            <AssistantAttachments
              key={`${message.id}-${index}`}
              attachment={attachment}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

/**
 * Memoised so a streaming reply only re-renders its own bubble. Redux hands back a
 * new array on every flush, but unchanged messages keep their object identity.
 */
export default React.memo(AssistantMessageBubble);
